module.exports = __webpack_public_path__ + "static/media/rings-spinner.20189b64.svg";